module.exports = __webpack_public_path__ + "img/blank-eks.6bb99861.jpg";